import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const AuthorGuidelines = () => {
  return (
    <div style={{ paddingTop: '90px' }}>
      <Container>
        <h1 className="mb-4">Author Guidelines</h1>
        <div className="card shadow-sm">


          <div className="card-body ">
            <h2 className="h4 mb-3">Journal of Asia Entrepreneurship and Sustainability</h2>

            <h3 className="h5 mt-4 mb-3">1. Submission Guidelines</h3>
            <p>Authors are invited to submit original, unpublished research articles, review papers, case studies, and book reviews that are not under consideration for publication elsewhere. Submissions must be in English and should follow the journal's formatting guidelines.</p>

            <h3 className="h5 mt-4 mb-3">2. Manuscript Preparation</h3>
            <ul>
              <li>Manuscripts should be typed in Times New Roman, 12-point font, double-spaced with 1-inch margins.</li>
              <li>Title page should include: title, author(s) name(s), affiliation(s), and email address(es).</li>
              <li>Include an abstract of 150-250 words and 4-6 keywords.</li>
              <li>Main text should be structured as follows: Introduction, Literature Review, Methodology, Results, Discussion, Conclusion, and References.</li>
            </ul>

            <h3 className="h5 mt-4 mb-3">3. Referencing Style</h3>
            <p>Please use APA (7th edition) style for in-text citations and references. Ensure all references cited in the text are listed in the reference list and vice versa.</p>

            <h3 className="h5 mt-4 mb-3">4. Ethical Considerations</h3>
            <p>Authors must ensure that their work is original and properly cited. Plagiarism in any form is unacceptable. All submissions will be checked for plagiarism before the review process.</p>

            <h3 className="h5 mt-4 mb-3">5. Peer Review Process</h3>
            <p>All submissions undergo a double-blind peer review process. The review process typically takes 4-6 weeks. Authors will be notified of the editorial decision along with reviewers' comments.</p>

            <h3 className="h5 mt-4 mb-3">6. Submission Process</h3>
            <p>Manuscripts should be submitted through our online submission system. Please ensure all required files are uploaded before submission.</p>

            <div className="mt-5">
              <Link to="/submit-paper" className="btn btn-primary me-2">
                Submit Your Paper
              </Link>
            </div>

          </div>
        </div>
      </Container>

    </div>
  );
};

export default AuthorGuidelines;
